import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

const useSubjectUrlSync = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const setUrlTemplateId = useCallback(
        (templateId, replace = true) => {
            const params = new URLSearchParams(location.search);
            params.set("templateId", templateId);
            navigate(`${location.pathname}?${params.toString()}`, { replace, state: location.state });
        },
        [location.pathname, location.search, location.state, navigate]
    );

    return { setUrlTemplateId };
};

export default useSubjectUrlSync;
